export default __webpack_public_path__ + "static/media/fb.5233a04b.svg";